import React from "react";
import Lottie from "lottie-react";
import successAnimation from "./Success_Lottie.json";
import "./Success_Lottie.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Success_Lottie = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="success_modal_overlay">
      <div className="success_modal">
      

        {/* Header */}
        <div className="modal_header">
          <h2>Thank you!</h2>
          <p className="sub_text">for Reaching Out</p>
        </div>

          {/* Close button */}
        <div className="modal_close_btn" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} className="close_btn" />
        </div>

        {/* Animation */}
        <div className="lottie_wrapper">
          <Lottie
            animationData={successAnimation}
            loop={false}
            className="success_lottie"
          />
        </div>

        {/* Content */}
        <div className="modal_content">
          <p className="success_text">
            <span>Your request has been received successfully.</span>
            <br />
            Our team will review your requirements and contact you shortly with
            a custom pricing plan.
          </p>
        </div>

        {/* Footer */}
        <div className="modal_footer">
          <button className="back_home_btn" onClick={onClose}>
            Back To Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Success_Lottie;
